<template>
  <div class="container">
    <div>
      <div style="margin-bottom: 20px">
        <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
        <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
        <el-upload
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :show-file-list="false"
          :action="$baseUrl + 'api/uploadDictList'"
          :on-success="uploadExcelSuccess"
          :on-error="uploadExcelFailed"
          :before-upload="beforeExcelUpload"
          style="display: inline; margin-left: 10px">
          <el-button>上传</el-button>
        </el-upload>
        <el-button @click="exportData" style="margin-left: 10px">
          <a :href="exportUrl">下载模版</a>
        </el-button>
      </div>
      <div style="display: flex; border-width: 2px;" class="table-border">

        <div>
          <div
            style="display: flex; align-items: center; justify-content: center; height: 49px; background-color: lightgrey; color: #1879ff">
            字典类型
          </div>
          <el-tabs tab-position="left"
                   v-loading="$store.state.data.loading.DictType"
                   v-model="activeTypeIndex"
                   style="height: calc(100% - 49px);">
            <el-tab-pane v-for="(type, index) of $store.state.data.DictType" :key="type.id"
                         :label="type.name" :name="index+''">
            </el-tab-pane>
          </el-tabs>
        </div>

        <el-table :data="dictItemList" v-loading="loading" header-cell-class-name="table-head" :height="tableHeight">
          <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
          <el-table-column label="名称">
            <template #default="{row, $index}">
              <el-input v-if="$index === editItem.index" v-model="editItem.data.value"></el-input>
              <div v-else>{{row.value}}</div>
            </template>
          </el-table-column>
          <el-table-column label="编码">
            <template #default="{row, $index}">
              <el-input v-if="$index === editItem.index" v-model="editItem.data.code"></el-input>
              <div v-else>{{row.code}}</div>
            </template>
          </el-table-column>
          <el-table-column width="160" align="center" fixed="right">
            <template #header>
              <el-button icon="el-icon-plus" type="primary" @click="add" style="width: 66px"></el-button>
            </template>
            <template #default="{row, $index}">
              <div v-if="$index === editItem.index">
                <el-button type="text" @click="save" size="mini">保存</el-button>
                <el-button type="text" @click="cancelEdit" size="mini">取消</el-button>
              </div>
              <div v-else>
                <el-button type="text" @click="edit(row, $index)" size="mini">编辑</el-button>
                <el-button type="text" size="mini" @click="deleteDictItem(row)" class="danger">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'Dict',
    mixins: [resizeCaptureMixin],
    components: {},
    data () {
      return {
        loading: false,
        searchText: null,
        activeTypeIndex: 0,
        editItem: {
          index: null,
          data: null,
          add: false
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('dict/all').finally(() => {
          this.loading = false
        })
        this.$store.dispatch('data/kvList', 'DictType')
      },
      add () {
        this.cancelEdit()

        const newData = {
          value: null,
          code: null,
          type: this.activeType
        }
        this.$store.commit('dict/ADD', newData)

        const index = this.dictItemList.length - 1
        this.editItem.index = index
        this.editItem.data = newData
        this.editItem.add = true
      },
      edit (row, index) {
        this.cancelEdit()
        this.editItem.index = index
        this.editItem.data = this.$_.cloneDeep(row)
        this.editItem.add = false
      },
      save () {
        if (!this.editItem.data.value) {
          this.$message.warning('字典值不能为空')
          return
        }
        const add = this.editItem.add
        this.$store.dispatch('dict/saveOrUpdate', {
          ...this.editItem.data,
          index: this.editItem.index
        }).then(() => {
          this.$message.success(add ? '添加成功!' : '保存成功!')
        })

        this.cancelEdit()
      },
      cancelEdit () {
        if (this.editItem.add) {
          this.$store.commit('dict/REMOVE', {
            index: this.editItem.index,
            type: this.editItem.data.type
          })
        }

        this.editItem.index = null
        this.editItem.data = null
        this.editItem.add = false
      },
      deleteDictItem (dictItem) {
        this.$confirm(`确认删除字典成员【${dictItem.value}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('dict/delete', dictItem).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadDictTemplate'
      },
      dictItemList () {
        const list = this.$store.state.dict.itemList
        if (list.length === 0) return []
        const items = list[parseInt(this.activeTypeIndex)].elements || []
        if (!this.searchText) {
          return items
        }
        return items.filter(item => item.value.indexOf(this.searchText) > -1)
      },
      activeType () {
        const list = this.$store.state.dict.itemList
        if (list.length === 0) return null

        return list[parseInt(this.activeTypeIndex)].type
      },
      tableHeight () {
        return this.clientHeight - 224
      }
    },
    watch: {
      activeTypeIndex () {
        this.cancelEdit()
      }
    },
    beforeRouteLeave (to, from, next) {
      this.cancelEdit()
      next()
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }

  /deep/ .el-tabs--left .el-tabs__header.is-left {
    margin-right: 1px;
  }
</style>
